import { useEffect, useState } from "react";
import { getAccessTokenSilently } from "utils/AuthUtils";
import { UserAdministration } from "api";
import { getUserName } from "api/user-administration/user-administration";
import FormMultiSelect from "components/Forms/FormMultiSelect";
import { useAuth } from "context";
import { sortByLabel } from "../../utils/userSort";

/**
 * (Load users) and offer a multi-select of them.
 * @param {*} param0
 * @returns
 */
export default function FormSelectUser({ label, name, ...props }) {
  const { getAccessTokenSilently } = useAuth();
  const [users, setUsers] = useState([]);

  const PAGE_SIZE = 1000;

  useEffect(() => {
    getAccessTokenSilently().then((token) => {
      UserAdministration.getUsers(`size=${PAGE_SIZE}`).then((usersWrappedPage) => {
        setUsers(usersWrappedPage.page.content);
      });
    });
  }, [getAccessTokenSilently]);

  const userOptions = users?.map
    ? sortByLabel(
        users.map((user) => ({
          value: user.email,
          // Name isnt always unique, plus it isnt a secure identifier, so we must show email
          label: getUserName(user) + " (" + user.email + ")",
        })),
        (option) => option.label
      )
    : [];

  return <FormMultiSelect label={label} name={name} options={userOptions} {...props} />;
}
